const styles = () => ({
  detailContainer: {
    position: 'relative',
    overflowY: 'scroll',
    height: '0px',
    backgroundColor: 'rgba(0,0,0,.04)',
  },

  tableRow: {
    height: 58,
  },

  detailContainerExpanded: {
    position: 'relative',
    overflowY: 'scroll',
    backgroundColor: '#fafafa',
    transition: 'height 0.15s ease',
    height: '342px',
    paddingLeft: 10,
    borderLeft: '2px solid #ddd',
  },
});

export default styles;
